module.exports = __webpack_public_path__ + "static/god-is-not-great-0febdcaa03cfbd2a453652d6f3ef7ebb.jpg";